module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o telefone",
      "disabled": _vm.disabledAttribute
    },
    model: {
      value: (_vm.m_fieldAnswer.value),
      callback: function($$v) {
        _vm.$set(_vm.m_fieldAnswer, "value", $$v)
      },
      expression: "m_fieldAnswer.value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14549a19","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/fields/PhoneNumberField.vue
// module id = 686
// module chunks = 1